import React from 'react';
import Error from '.';
import Modal from 'react-modal';

Modal.setAppElement('body');

export default function NotAuthorizedError(): React.JSX.Element {
  return (
    <Modal
      className='fixed inset-0 flex items-center justify-center'
      overlayClassName='fixed inset-0 backdrop-blur-sm'
      isOpen={true}
      style={{
        content: {
          border: 'none',
        },
        overlay: {
          zIndex: '99999',
          backgroundColor: 'rgba(0,0,0,0.2)',
        },
      }}
    >
      <Error
        title='Access Denied'
        message='You do not have adequate permission to view this page. Please contact support to open a ticket.'
      />
    </Modal>
  );
}
